import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  logoContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['size-20'],
  },
  logoItemContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '105px',
    height: '30px',
    cursor: 'pointer',
    borderRadius: anatomy['size-4'],
    color: colors.primaryIcon,
    ':hover': {
      background: 'transparent',
      color: colors.accentIcon,
    },
  },
  logoPerfectionists: {
    width: 'auto',
    height: 'auto',
  },
  imageContainer: {
    fontFamily: fonts.din2014Regular,
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['size-4'],
    color: colors.primaryText,
    ':hover': {
      color: colors.accentText,
    },
  },
  imageItem: {
    display: 'flex',
    flexDirection: 'column',
    width: '178px',
    height: '94px',
    background: colors.brandGhostBackground,
    borderRadius: anatomy.borderRadiusS,
    alignItems: 'center',
    justifyContent: 'center',
  },
  imageText: {
    color: colors.accentText,
    fontSize: typography['fontSizeCaption-3'],
    lineHeight: typography['lineHeightCaption-2'],
  },
  imageDescription: {
    color: 'inherit',
    fontSize: typography['fontSizeCaption-3'],
    lineHeight: typography['lineHeightCaption-2'],
  },
  titleContainer: {
    fontFamily: fonts.din2014Demi,
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['size-20'],
    color: colors.primaryText,
  },
  titleOne: {
    fontSize: typography['fontSizeBody-1'],
    lineHeight: typography['lineHeightBody-1'],
    ':hover': {
      color: colors.accentText,
    },
  },
  titleTwo: {
    fontSize: typography['fontSizeBody-2'],
    lineHeight: typography['lineHeightBody-2'],
    ':hover': {
      color: colors.accentText,
    },
  },
});
